<template>
  <div v-if="externalVueModel && proposalModel">
    <h1 data-test="checkout-construction-headline" v-html="heading" />
    <section>
      <article class="flow-group">
        <div class="header-with-icon push-down">
          <span
            class="icon-large"
            :class="'policy-type-name-' + [vueModel.Type]"
            data-test="checkout-construction-icon"
          />
          <ul class="no-bullet">
            <li
              v-for="(asset, index) in vueModel.Asset.AssetDetailLines"
              :key="asset + '-' + index"
              :data-test="'checkout-construction-asset-detail-line-' + index"
            >
              {{ asset }}
            </li>
          </ul>
        </div>
        <div id="SelectedTakeoverDate" class="control">
          <h3-and-tooltip
            :h3="proposalModel.LabelStartDate"
            :tooltip="proposalModel.TooltipStartDate"
            data-test="checkout-construction-h3-and-tooltip-start-date"
          />
          <date-picker
            id="startdate"
            name="StartDate"
            :date="vueModel.AdditionalInformation.StartDate"
            :min-date="currentDate"
            class="datepicker"
            :validate="{ required: true }"
            :placeholder="proposalModel.PlaceholderSelectStartDate"
            :data-vv-as="proposalModel.FieldNameStartDate"
            data-test="checkout-construction-date-picker-start-date"
            @date-changed="dateChanged"
          />
          <ValidationError name="StartDate" />
        </div>
      </article>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import mixin from './CheckoutMixin.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import DatePicker from '@/components/UI/Pickadate.vue';
import ConstructionVueModel from './interfaces/ConstructionVueModel';
import ConstructionProposalModel from './interfaces/ConstructionProposalModel';

export default defineComponent({
  name: 'Construction',
  components: {
    H3AndTooltip,
    ValidationError,
    DatePicker
  },
  mixins: [mixin],
  inject: ['$validator'],
  props: {
    externalVueModel: {
      type: Object as PropType<ConstructionVueModel | null>,
      default() {
        return null;
      }
    },
    proposalModel: {
      type: Object as PropType<ConstructionProposalModel | null>,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel
    };
  },
  computed: {
    heading(): string {
      if (this.vueModel && this.vueModel.Name && this.proposalModel) {
        return `${
          this.proposalModel.LabelExtraInformationForYour
        } ${this.vueModel.Name.toLowerCase()}`;
      }
      return '';
    }
  },
  watch: {
    vueModel: {
      handler(): void {
        this.$emit('vue-model-updated', this.vueModel);
      },
      deep: true
    }
  },
  methods: {
    dateChanged(param: string): void {
      this.vueModel!.AdditionalInformation!.StartDate = param;
    }
  }
});
</script>
@/components/Feature/Forms/BaseValidationError.vue
